import _extends from "@babel/runtime/helpers/extends";
/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import React from 'react';
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { jsx } from '@emotion/react';
import { alignmentPositionMap } from '@atlaskit/adf-schema';
var MarkWrapper = function MarkWrapper(props) {
  var dataAlign = props['data-align'] ? alignmentPositionMap[props['data-align']] : undefined;
  return jsx("div", _extends({
    style: {
      textAlign: dataAlign
    }
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
  }, props), props.children);
};
export default function Alignment(props) {
  return jsx(MarkWrapper
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
  , {
    className: "fabric-editor-block-mark fabric-editor-alignment",
    "data-align": props.align
  }, props.children);
}